import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './Components/Header'
import Footer from './Components/Footer'
import Home from './Components/Home'
import Login from './Components/Login/Login'
import { UserStorage } from './UserContext'
import ProtectedRouter from './Helpers/ProtectedRouter'
import User from './Components/User/User'
import Photo from './Components/Photo/Photo'
import './App.css'
import UserProfile from './Components/User/UserProfile'
import NotFound from './Components/NotFound'

const App = ()=> {
  return (
   <div className='App'>
    <BrowserRouter>
      <UserStorage>
        <Header />
          <main className='AppBody'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='login/*' element={<Login />} />
            <Route path='conta/*' element={<ProtectedRouter><User /></ProtectedRouter>} />
            <Route path='foto/:id' element={<Photo />} />
            <Route path='perfil/:user' element={<UserProfile />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
          </main>
        <Footer />
      </UserStorage>
    </BrowserRouter>
   </div>
  )
}

export default App